<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><img alt="" src="OEBPS/images/3-1.jpg"/></p>
<h1 class="chapter">Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/int.htm">Introduction                    <img alt="" src="OEBPS/images/4-1.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c01.htm">Tilly the Doll                   <img alt="" src="OEBPS/images/4-2.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c02.htm">Harry the Monster          <img alt="" src="OEBPS/images/4-3.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c03.htm">Alexander the Caterpillar <img alt="" src="OEBPS/images/4-4.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c04.htm">Lou-Lou the Panda         <img alt="" src="OEBPS/images/4-5.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c05.htm">Preston the Lion             <img alt="" src="OEBPS/images/4-6.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c06.htm">Pearl the Zebra              <img alt="" src="OEBPS/images/4-7.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c07.htm">Darcy the Dinosaur        <img alt="" src="OEBPS/images/4-8.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c08.htm">Mabelle the Mouse        <img alt="" src="OEBPS/images/4-9.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c09.htm">Gerbera the Giraffe        <img alt="" src="OEBPS/images/4-10.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c10.htm">Alvin the Alien               <img alt="" src="OEBPS/images/4-11.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c11.htm">Polly the Pig                  <img alt="" src="OEBPS/images/4-12.jpg"/></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c12.htm">Finnegan the Frog          <img alt="" src="OEBPS/images/4-13.jpg"/></a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/tool.htm">Tools and Techniques</a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/temp.htm">Templates</a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/supp.htm">Suppliers</a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ata.htm">About the Authors</a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ack.htm">Acknowledgments</a><br/><br/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/copy.htm">Copyright</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?614d81a0